<template>
  <footer class="footer">
    <div class="footer-content">
      <div class="footer-column">
        <h3>产品中心</h3>
        <p>用科技让台球更精彩</p>
        <ul>
          <li>AI 灵犀系统</li>
          <li>云竞台球平台</li>
          <li>智能设备</li>
        </ul>
      </div>
      <div class="footer-column">
        <h3>解决方案</h3>
        <ul>
          <li>球房升级</li>
          <li>赛事运营</li>
          <li>教学培训</li>
        </ul>
      </div>
      <div class="footer-column">
        <h3>联系我们</h3>
        <ul>
          <li>加盟咨询</li>
          <li>商务合作</li>
          <li>媒体联络</li>
        </ul>
      </div>
    </div>
    <div class="copyright">
      © 2025 奇点台球. All rights reserved.
    </div>
  </footer>
</template>

<script>
export default {
  name: 'Footer'
}
</script>

<style scoped>
.footer {
  background-color: #1a1a1a;
  color: #fff;
  padding: 4rem 5% 2rem;
}

.footer-content {
  display: flex;
  justify-content: space-around;
  max-width: 1200px;
  margin: 0 auto;
  margin-bottom: 3rem;
}

.footer-column {
  text-align: left;
}

.footer-column h3 {
  color: #fff;
  font-size: 1.2rem;
  margin-bottom: 1rem;
}

.footer-column p {
  color: #666;
  margin-bottom: 1rem;
}

.footer-column ul {
  list-style: none;
  padding: 0;
}

.footer-column ul li {
  color: #666;
  margin-bottom: 0.5rem;
  font-size: 0.9rem;
}

.copyright {
  text-align: center;
  color: #666;
  font-size: 0.9rem;
  padding-top: 2rem;
  border-top: 1px solid #333;
}

@media (max-width: 768px) {
  .footer-content {
    flex-direction: column;
    gap: 2rem;
    text-align: center;
  }

  .footer-column {
    text-align: center;
  }
}
</style>